import React from 'react';
import PropTypes from 'prop-types';

const NumberInput = (props) => {
    const handleNumberInput = (e) => {
        const value = e.target.value;

        // Only update if the input is a valid number
        if (!isNaN(value) || value === '.') {
            if (props.onChange) {
                props.onChange(value);
            }
        }
    };
    const inputRef = React.useRef(null);

    React.useEffect(() => {
        const handleKeyDown = (e) => {
            // Only handle if this input is focused
            if (document.activeElement !== inputRef.current) {
                return;
            }

            if (e.key === 'ArrowUp') {
                e.preventDefault();
                const currentValue = parseFloat(props.value) || 0;
                const increment = e.shiftKey ? 10 : 1;
                const newValue = currentValue + increment;
                if (props.onChange) {
                    props.onChange(newValue.toString());
                }
            } else if (e.key === 'ArrowDown') {
                e.preventDefault();
                const currentValue = parseFloat(props.value) || 0;
                const decrement = e.shiftKey ? 10 : 1;
                const newValue = currentValue - decrement;
                if (props.onChange) {
                    props.onChange(newValue.toString());
                }
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [props.value, props.onChange]);

    return (
        <div className={`number-input-wrapper ${props.center ? 'number-input-wrapper--center' : ''}`}>
            <div className="form-item suffix-inside--wrapper">
                <label htmlFor={props.label + props.suffix} className="form-item__label">
                    {props.label}
                </label>
                <div className='suffix-inside-input'>
                    <input ref={inputRef} id={props.label + props.suffix} type="text" value={props.value} className={`input__input ${props.invalid ? 'error' : ''}`}
                        onChange={handleNumberInput}
                    />
                    <span className="suffix-inside">{props.suffix}</span>
                </div>
            </div>
            {props.assistiveText &&
                <p className='assistive-text'>{props.assistiveText}</p>
            }
        </div >
    );
};

NumberInput.props = {
    id: PropTypes.string,
    center: PropTypes.bool,
    suffix: PropTypes.string,
    assistiveText: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.string,
    children: PropTypes.element,
    invalid: PropTypes.bool,
    onChange: PropTypes.func
};

export default NumberInput;
